import React, { useEffect, useState } from "react";
import { X, ArrowRight, Sparkles } from "lucide-react";
import "./OpportunitiesPopup.css";

const OpportunitiesPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const alreadyClosed = sessionStorage.getItem(
      "ima-opportunities-popup-closed"
    );

    if (!alreadyClosed) {
      const timer = setTimeout(() => {
        setOpen(true);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (!open) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closePopup();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  const closePopup = () => {
    setOpen(false);

    try {
      sessionStorage.setItem(
        "ima-opportunities-popup-closed",
        "true"
      );
    } catch (error) {
      // O popup continua funcionando mesmo se o storage estiver indisponível.
    }
  };

  if (!open) return null;

  return (
    <div
      className="ima-opportunities-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="ima-opportunities-title"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          closePopup();
        }
      }}
    >
      <div className="ima-opportunities-modal">
        <button
          type="button"
          className="ima-opportunities-close"
          onClick={closePopup}
          aria-label="Fechar oportunidades"
        >
          <X size={22} />
        </button>

        <div className="ima-opportunities-header">
          <div className="ima-opportunities-badge">
            <Sparkles size={15} />
            OPORTUNIDADES ABERTAS
          </div>

          <h2 id="ima-opportunities-title">
            Transforme ideias em impacto.
          </h2>

          <p>
            O Instituto IMA está com inscrições abertas para
            programas voltados à inovação, empreendedorismo
            e desenvolvimento de novos projetos.
          </p>
        </div>

        <div className="ima-opportunities-grid">
          {/* NFSB */}
          <article className="ima-opportunity-card ima-opportunity-nfsb">
            <div className="ima-opportunity-content">
              <span className="ima-opportunity-status">
                INSCRIÇÕES ABERTAS
              </span>

              <div>
                <span className="ima-opportunity-type">
                  Programa de Aceleração
                </span>

                <h3>
                  Nunca Foi Só Batom
                </h3>

                <p>
                  Uma oportunidade para impulsionar negócios,
                  projetos e iniciativas com potencial de
                  crescimento e impacto.
                </p>
              </div>

              <a
                href="/aceleracaonfsb"
                className="ima-opportunity-button"
              >
                Conhecer oportunidade
                <ArrowRight size={18} />
              </a>
            </div>

            <div
              className="ima-opportunity-decoration"
              aria-hidden="true"
            >
              NFSB
            </div>
          </article>

          {/* MAKER */}
          <article className="ima-opportunity-card ima-opportunity-maker">
            <div className="ima-opportunity-content">
              <span className="ima-opportunity-status">
                INSCRIÇÕES ABERTAS
              </span>

              <div>
                <span className="ima-opportunity-type">
                  Inovação & Indústria
                </span>

                <h3>
                  Do Maker
                  <br />
                  à Indústria
                </h3>

                <p>
                  Tire seu projeto do protótipo e aproxime sua
                  solução do mercado, da indústria e de novas
                  oportunidades.
                </p>
              </div>

              <a
                href="/programadomakeraindustria"
                className="ima-opportunity-button"
              >
                Conhecer oportunidade
                <ArrowRight size={18} />
              </a>
            </div>

            <div
              className="ima-opportunity-decoration"
              aria-hidden="true"
            >
              MAKER
            </div>
          </article>
        </div>

        <div className="ima-opportunities-footer">
          <span>INSTITUTO IMA</span>

          <button
            type="button"
            onClick={closePopup}
          >
            Continuar navegando
          </button>
        </div>
      </div>
    </div>
  );
};

export default OpportunitiesPopup;
